/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";

import { AiOutlineSearch } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import styles from "./styles/Navbar.module.scss";
import { BellIcon, SettingIcon } from "../../svg";
import NotificationModal from "Components/Modals/NotificationModal";
import SettingModal from "Components/Modals/SettingModal";
import { RiSearch2Line } from "react-icons/ri";


interface NavbarProps {
    isSearchBar?: boolean;
    isSettingButton?: boolean;
    handleToggle: () => void;
    logoutModalHandler: () => void;
    deleteUserModalHandler: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ isSearchBar = true, handleToggle, logoutModalHandler, deleteUserModalHandler }) => {
    const [notificationModal, setNotificationmModal] = useState<boolean>(false);
    const [settingModal, setSettingModal] = useState<boolean>(false);
    const [indication, setIndication] = useState<boolean>(true);

    const handleNotificationModalOpen = () => {
        setNotificationmModal(true);
    };

    const handleNotificationModalClose = () => {
        setNotificationmModal(false);
    };

    const handleSettingModalOpen = () => {
        setSettingModal(true);
    };

    const handleSettingModalClose = () => {
        setSettingModal(false);
    };

    return (
        <div className={styles.Navbar}>
            <div className={styles.titleContainer}>
                <span onClick={handleToggle} className={styles.toggleButton}><GiHamburgerMenu /></span>
                {/* <h3 className={styles.title}>{title}</h3> */}
                {isSearchBar ?
                    <div className={styles.search}>
                        <div className={styles.searchButton}>
                            <RiSearch2Line />
                        </div>
                        <input
                            type="search"
                            placeholder="Search "
                        // value={search}
                        // onChange={(e) => dispatch(setValue(e.target.value))}
                        />
                    </div>
                    : ''}

            </div>
            <div className={`${styles.notificationButton} `} onClick={handleNotificationModalOpen}>
                <BellIcon />
                <span className={`${indication ? styles.indicator : ""}`}></span>
            </div>

            <div className={`${styles.settingButton} `} onClick={handleSettingModalOpen}>
                <SettingIcon />
            </div>


            {notificationModal ? (
                <NotificationModal
                    handleNotificationModalClose={handleNotificationModalClose}
                // data={""}
                // onOkay={handleNotificationModalClose}
                />
            ) : null}

            {settingModal ? (
                <SettingModal
                    handleSettingModalClose={handleSettingModalClose}
                    logoutModalHandler={logoutModalHandler}
                    deleteUserModalHandler={deleteUserModalHandler}
                // data={""}
                // onOkay={handleNotificationModalClose}
                />
            ) : null}


        </div >
    )
}

export default Navbar;